import { Link } from "react-router-dom";

const LOGO_URL =
  "/logo.jpg";

/**
 * Dkarez brand mark — uses the official uploaded logo image.
 * The brand mark itself is iconic; wordmark next to it for navbar/contextual use.
 */
export default function Logo({ size = "md", withText = true, className = "" }) {
  const dim = size === "lg" ? 56 : size === "sm" ? 32 : 44;
  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`} data-testid="logo-home-link">
      <div
        className="relative rounded-full overflow-hidden transition-all duration-500 group-hover:scale-105 group-hover:rotate-[6deg]"
        style={{
          width: dim,
          height: dim,
          background: "radial-gradient(circle, #FDE9F1 0%, #FFFCF7 70%)",
          boxShadow: "0 6px 18px -6px rgba(233, 30, 99, 0.35)",
        }}
      >
        <img
          src={LOGO_URL}
          alt="Dkarez Community Support CIC"
          width={dim}
          height={dim}
          className="w-full h-full object-cover"
          style={{ mixBlendMode: "multiply" }}
          loading="eager"
        />
      </div>
      {withText && (
        <div className="flex flex-col leading-none">
          <span className="font-display-bold text-2xl sm:text-3xl tracking-tight text-brand-primary font-extrabold">DKAREZ</span>
          <span className="font-display-bold text-[0.65rem] sm:text-[0.75rem] tracking-[0.2em] mt-1 text-brand-primary font-semibold uppercase">COMMUNITY SUPPORT CIC</span>
        </div>
      )}
    </Link>
  );
}
